import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tabs } from '@mui/material';
import LinkTab from '../LinksTab';
import { mainColor } from 'src/theme';
import { IPanelLinks } from 'src/models/IPanelLinks';
import './styles.scss';

interface IProps {
  links: IPanelLinks[];
}

const TabList: FC<IProps> = ({ links }) => {
  const [value, setValue] = useState(0);
  const { pathname } = useLocation();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => setValue(newValue);

  useEffect(() => {
    if (links) {
      if (pathname !== '/') {
        const index = links.map(link => link.path).lastIndexOf(pathname);
        if (index > -1) setValue(index);
        else setValue(2);
      } else setValue(2);
    }
  }, [pathname, links]);

  return (
    <Tabs
      orientation='vertical'
      variant='scrollable'
      value={value}
      onChange={handleChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: mainColor,
          width: 3,
          borderRadius: 3
        }
      }}
    >
      {links &&
        links.map((elem, i) => (
          <LinkTab
            key={i}
            link={elem.path as string}
            title={elem.name}
            icon={elem.icon}
            iconPosition='start'
          />
        ))}
    </Tabs>
  );
};
export default TabList;
